module.exports = __webpack_public_path__ + "static/media/signup-back-arrow.d0651731.svg";